import React from 'react'
import * as $ from 'jquery'
import * as d3 from 'd3'
import XMLParser from 'react-xml-parser'
import * as events from 'events'

import { connect } from "react-redux";
import { compose, setDisplayName, withStateHandlers } from 'recompose'
import {
  setCurrPage,
  setPageCount,
  setBookReady,
  setBookLoadingProgress,
  setPageRendering,
  setPageNumPending,
  updateReadPosition,
  setChapters,
  setFullscreenMode,
  addNote,
  setInBookmarks,
  highlightAction,
  setOpenAddNote,
  setEditNoteText,
  setSearchResult,
  setAppearenceTextColor,
  setPageReady,
  addPrevState,
  removePrevState,
  replaceState,
  deleteNote, updateNote, setSelectedNote
} from "../../../actions/reader";
import {nextDropdown} from "../../../actions/dropdown";
import { Navigation } from "../../Reader/components/Navigation/Navigation";

import './PdfReader.css'
import {BOOKMARK_TEXT_LIMIT, CLOUD_URL, REQUEST_LIMIT} from "../../../constants";
import {
  closePopups,
  dateForSaveNote,
  onMouseUp, notChildren, getStateIndex
} from "../../../utilities/utilities";
import {Scrollbars} from "react-custom-scrollbars";
import {Pagination} from "../../Reader/components/Pagination/Pagination";

import {
  parseXmlToPage,
  getTextPosition,
  addHighlightInPage,
  addNoteInPage,
  isEqual,
  getPdtPosition,
  getOffset,
  getOver,
  setRect
} from "../../../utilities/pdfUtilities";
import {HighlightModal} from "../../Reader/components/HighlighModal/HighlightModal";
import {Loading} from "../../Shared/Loading/Loading";

const state = {
  rendition: {},
  page: {},
  rangeRef: '',
  scale: 1,
  renderPage: '',
  scrollPosition: 0,
  bookHash: '0',
  onAddHighlights: '',
  UI: {},
  renderOptions: {},
  setPagesText: {},
  pagesText: [],
  onSelected: '',
  changeHighlighModalPosition: '',
  selectedRange: '',
  pagesXml: [],
  setPageXml: '',
  pagesPng: [],
  backButton: {
    status: false,
    page: 1,
    location: 0
  },
  forwardButton: {
    status: false,
    page: 1,
    location: 0
  },
  stateIndex: 0,
  eventEmmiter: {},
}

const stateHandlers = {
  onSaveReaderPosition: ({bookHash, currPage}, {pageCount, updateReadPosition, bookId}) => (closeReader = false) => {
    if (parseInt(currPage, 10) === 0 || parseInt(currPage, 10) === 1) return

    const percentage =  Math.ceil(currPage*100/pageCount)

    const read_position = {
      pointer: "#pdfloc("+bookHash+","+(currPage-1)+")",
      pointer_pb: "pbr:/page?page="+(currPage-1)+"##pdfloc("+bookHash+","+(currPage-1)+")",
      page: currPage,
      offs: percentage,
      pages_total: pageCount
    }

    updateReadPosition(read_position, bookId)

    if (closeReader) {
      setTimeout(() => {
        window.location = CLOUD_URL
      }, 1500)
    }
  },
  onAddBookMark: ({rendition, bookHash, currPage}, {setInBookmarks, bookmarks, bookId, addNote}) => () => {
    let position = "pbr:/page?page="+(currPage-1)+"##pdfloc("+bookHash+","+(currPage-1)+")"

    let isNew = true
    let note = {
      type: {
        value: "bookmark",
        updated: dateForSaveNote()
      },
      mark: {
        anchor: position,
        created:  Math.round(new Date() / 1000),
        updated: dateForSaveNote()
      },
      quotation: {
        begin: position,
        end: position,
        text: '',
        updated: dateForSaveNote()
      }
    }

    for (let i=0; i < bookmarks.length; i++) {
      let bookmark = bookmarks[i]
      if (bookmark.mark.anchor === note.mark.anchor) {
        isNew = false
      }
    }

    if (isNew) {
      addNote(note, bookId)
      setInBookmarks(true)
    }
    window.getSelection().removeAllRanges()
  },
  onDeleteNote: ({eventEmmiter, pagesXml, rendition, target, selectedText, selectedRange, renderOptions, coords, currPage},
                 {selectedNote, highlights, bookId, deleteNote}) => (note, isHighlight = false) => {
    if (!note && Object.keys(selectedNote).length > 0) {
      note = selectedNote
      isHighlight = true
    }

    if (note) {
      if ( isHighlight ) {
        let begin = getOffset(note.quotation.begin)
        let end = getOver(note.quotation.end)

        if (!note.uuid) {
          highlights.map(h => {
            if (h.quotation.begin === note.quotation.begin &&
              h.quotation.end === note.quotation.end) {
              note.uuid = h.uuid
            }
            return h
          })
        }

        if (note.note) {
          let marks = document.getElementsByClassName('mark')
          for (let i = 0; i < marks.length; i++) {
            let mark = marks[i]
            let mOffs = mark.dataset.begin
            let mOver = mark.dataset.end

            if (mOffs === begin && mOver === end) {
              $(mark).remove()
            }
          }
        }

        let emitter = function emmiter() {
          eventEmmiter.emit('markClicked', note)
        }
        for (let i=0; i < rendition.length; i++) {
          let svg = rendition[i]
          let rects = svg.selectAll('rect')._groups[0]
          for (let l=0; l < rects.length; l++) {
            let rect = rects[l]
            let rOffs = $(rect).attr('data-offset')
            let rOver = $(rect).attr('data-over')

            if (rOffs === begin && rOver === end) {
              $(rect).removeAttr('class')
              $(rect).removeAttr('data-offset')
              $(rect).removeAttr('data-over')

              rect.removeEventListener("mousedown", emitter)
              rect.removeEventListener("mouseup", emitter)
            }
          }
        }
        deleteNote(note.uuid, bookId, true)
      } else {
        deleteNote(note.uuid, bookId)
      }
    }
  },
  onLoadHighlight: ({onRenderPage, currPage, stateIndex}, {prevStates, addPrevState, textFlow}) => (position) => {
    position = getPdtPosition(position)
    if (textFlow === '2page' && position % 2 === 0) {
      position = position - 1
    }
    let index = getStateIndex(prevStates, {page: currPage, location: currPage})
    let statePage = index > 0 ? currPage +'-'+ index : currPage
    addPrevState(statePage, currPage, stateIndex)
    if (stateIndex === 0) {
      window.history.replaceState({page: statePage, location: currPage}, null,
        document.URL);
    }
    window.history.pushState({page: statePage, location: currPage}, null,
      document.URL);
    onRenderPage(position, textFlow)
    return {
      currPage: position,
      backButton: {status: true, page: currPage, location: currPage},
      forwardButton: {status: false},
      stateIndex: 0
    }
  },
  onLoadBookMark: ({onRenderPage, currPage, stateIndex}, {prevStates, addPrevState, textFlow}) => (position) => {
    position = getPdtPosition(position)
    if (textFlow === '2page' && position % 2 === 0) {
      position = position - 1
    }
    let index = getStateIndex(prevStates, {page: currPage, location: currPage})
    let statePage = index > 0 ? currPage +'-'+ index : currPage
    addPrevState(statePage, currPage, stateIndex)
    if (stateIndex === 0) {
      window.history.replaceState({page: statePage, location: currPage}, null,
        document.URL);
    }
    window.history.pushState({page: statePage, location: currPage}, null,
      document.URL);
    onRenderPage(position, textFlow)
    return {
      currPage: position,
      backButton: {status: true, page: currPage, location: currPage},
      forwardButton: {status: false},
      stateIndex: 0
    }
  },
  onChangeViewMode: ({onRenderPage, currPage}) => (view) => {
    if (view === '2page' && currPage % 2 === 0) {
      currPage = currPage - 1
    }
    onRenderPage(currPage, view)
    return {currPage: currPage}
  },
  onLoad: ({rendition}) => (ref, isSecond = false) => {
    if (!isSecond) {
      rendition = []
    }
    rendition.push(ref)
    return {rendition: rendition}
  },
  setOnLoad: () => (onLoad) => ({
    onLoad: onLoad
  }),
  setBookHash: () => (size) => {
    if (!size) return
    size = size.toString(16)
    let hash = size.substr(size.length - 4)
    while(hash.charAt(0) === '0')
    {
      hash = hash.substr(1)
    }
    return {bookHash: hash}
  },
  setAddHighlightsMethod: () => (onAddHighlights) => ({
    onAddHighlights: onAddHighlights
  }),
  onGetChapters: (state, {pageCount, bookInfo, setChapters}) => () => {
    let chapters = []

    const getSubItems = (items) => {
      let newItems = []
      if (items) {
        for (let i=0; i < items.length; i++) {
          let item = items[i]
          if (item.title && item.title.length > 0) {
            item.items = getSubItems(item.items)
            let page = parseInt(item.url.split('page=')[1], 10) + 1
            if (page === 0) page = 1
            if (page <= pageCount) {
              newItems.push({
                label: item.title,
                href: page,
                page: page,
                subitems: item.items
              })
            }
          }
        }
      }
      return newItems
    }

    if (bookInfo.toc) {
      bookInfo.toc.forEach((chapter) => {
        chapter.items = getSubItems(chapter.items)
        let page = parseInt(chapter.url.split('page=')[1], 10) + 1
        if (page === 0) page = 1
        if (page <= pageCount) {
          chapters.push({
            label: chapter.title,
            href: page,
            page: page,
            subitems: chapter.items
          })
        }
      })
    }

    setChapters(chapters)
  },
  onSearch: ({rendition}, {pageCount, setSearchResult}) => (e) => {
    let q = e.target.value.toLowerCase()
    let pagesContent = []

    if(q.length < 3) {
      setSearchResult([])
      return
    }

    const findInPage = (page) => {
      let str = ''
      page.getTextContent().then((content) => {
        content.items.forEach((item) => {
          str += item.str !== ' ' ? item.str.trim() + ' ' : ''
        })
        str = str.replace(/’s/g,' s')
            .replace(/\s\s+/g, ' ')
        pagesContent.push(str)
      })
    }
    let pages = []; while (pages.length < rendition.numPages) pages.push(pages.length + 1);
    Promise.all(pages.map(function (num) {
      return rendition.getPage(num).then(findInPage)
    }))

    let wait = setInterval(() => {
      if (pagesContent.length === pageCount) {
        let results = []
        let limit = 70

        pagesContent.forEach((content, index) => {
          let contentForSearch = content.toLowerCase()
          let pos = contentForSearch.indexOf(q)
          let flag = pos > -1
          if (flag) {
            let excerpt = content.substr(pos - limit/2, limit);
            excerpt = "..." + excerpt + "...";
            let chapterTitle = ''

            results.push({range: index+1, text: excerpt, chapterTitle: chapterTitle, page: index+1})
          }
        })
        setSearchResult(results)
        clearInterval(wait)
      }
    }, 200)
  },
  onChangeChapter: ({onRenderPage, currPage, stateIndex}, {prevStates, addPrevState, textFlow}) => (chapterHref) => {
    if (chapterHref === '') return
    if (textFlow === '2page' && chapterHref % 2 === 0) {
      chapterHref = chapterHref - 1
    }
    let index = getStateIndex(prevStates, {page: currPage, location: currPage})
    let statePage = index > 0 ? currPage +'-'+ index : currPage
    addPrevState(statePage, currPage, stateIndex)
    if (stateIndex === 0) {
      window.history.replaceState({page: statePage, location: currPage}, null,
          document.URL);
    }
    window.history.pushState({page: statePage, location: currPage}, null,
        document.URL);
    onRenderPage(chapterHref, textFlow)
    return {
      currPage: chapterHref,
      backButton: {status: true, page: currPage, location: currPage},
      forwardButton: {status: false},
      stateIndex: 0
    }
  },
  setOnRenderPage: () => (onRenderPage) => ({
    onRenderPage: onRenderPage
  }),
  onRenderPage: ({stateIndex, onLoad, onCachPages, setPagePng, setPageXml, pagesXml, pagesPng, onAddHighlights, scale,
                   bookHash, onRenderPage, onSelected, changeHighlighModalPosition, activeHighlight},
                 {prevStates, replaceState, book, setBookLoadingProgress, setPageReady, toggleActiveHighlight, setOpenAddNote,
                   bookInfo: {baseUrl}, pages, setPageNumPending, setPageRendering, pageCount,
                   pageNumPending, updateReadPosition, bookId, setInBookmarks, bookmarks, textFlow }) => (num, view, clear = true, isNext = true, set = true) => {
    setPageRendering(true)
    setPageReady(false)
    let viewerContent = document.getElementById('viewer-content')

    if (num <= pageCount && num > 0) {
      if (clear) {
        viewerContent.innerHTML = ''
      }

      setInBookmarks(false)
      bookmarks.forEach((bookmark) => {
        let page = getPdtPosition(bookmark.mark.anchor)
        if (textFlow === '2page' && num === page+1) {
          setInBookmarks(true)
        } else if (page === num) {
          setInBookmarks(true)
        }
      })

      let pageWrap = document.createElement('div')
      pageWrap.classList.add('page')
      pageWrap.setAttribute('data-page-number', num)

      if (isNext) {
        viewerContent.appendChild(pageWrap)
      } else {
        $(viewerContent).prepend(pageWrap)
      }

      let pageLayer = document.createElement('div')
      pageLayer.classList.add('pngWrapper')
      $(pageWrap).append(pageLayer)
      let img = document.createElement('img')
      img.classList.add('page-img')
      $(pageLayer).append(img)
      let textLayer = document.createElement('div')
      textLayer.classList.add('svgWrapper')
      $(pageWrap).append(textLayer)
      let svg = d3.select(textLayer).append('svg')
      if (view) {
        onLoad(svg)
      } else {
        onLoad(svg, true)
      }

      if (pagesPng[num-1]) {
        setPageReady(true)
        let objectURL = pagesPng[num-1]
        img.src = objectURL
      } else {
        let requestLimit = 0
        const getPngForPage = (requestLimit) => {
          fetch(`${baseUrl}large/page-${num-1}.png`)
            .then(res => res.blob())
            .then(blob => {
              setPageReady(true)
              let objectURL = URL.createObjectURL(blob)
              img.src = objectURL
              setPagePng(num-1, objectURL)
            }).catch(e => {
              if (requestLimit < REQUEST_LIMIT) {
                getPngForPage(requestLimit+1)
              }
          })
        }
        getPngForPage(requestLimit)
      }

      if (pagesXml[num-1]) {
        let xml = pagesXml[num-1].xml
        let xmlText = pagesXml[num-1].xmlText
        if (!xmlText || !xml || Object.keys(xml.attributes).length === 0) return
        let size = xml.attributes.size.split(',')

        let width = viewerContent.offsetWidth*scale
        if (textFlow === '2page') {
          width = (width/2) - 40
        } else if ($(viewerContent).parent().css('padding-left') === '20px') {
          width = width - 40
        }
        parseXmlToPage(xml, svg, onSelected, changeHighlighModalPosition, toggleActiveHighlight,
            activeHighlight, setOpenAddNote, null, clear)
        pageLayer.style.width = width + 'px'
        svg.attr('viewBox', '0,0,' + size[0] + ',' + size[1])
        textLayer.style.width = width + 'px'

        setPageRendering(false)
        onAddHighlights(num, xmlText, svg)
      } else {
        let requestLimit = 0
        const getXmlForPage = (requestLimit) => {
          fetch(`${baseUrl}page-${num-1}.xml`)
            .then(res => res.text())
            .then(xmlText => {
              if (xmlText.indexOf('BlobNotFound') > -1) {
                setPageRendering(false)
                return
              }
              //xmlText = unescape(encodeURIComponent(xmlText))
              xmlText = xmlText.replace(/<\/l>[\s\S]*?<l/g, '</l><l')
              let xml = new XMLParser().parseFromString(xmlText);
              if (!xmlText || !xml || Object.keys(xml.attributes).length === 0) return
              let size = xml.attributes.size.split(',')

              let width = viewerContent.offsetWidth*scale
              if (textFlow === '2page') {
                width = (width/2) - 40
              }
              setPageXml(num-1, xml, xmlText)
              parseXmlToPage(xml, svg, onSelected, changeHighlighModalPosition, toggleActiveHighlight,
                activeHighlight, setOpenAddNote, null, clear)
              pageLayer.style.width = width + 'px'
              svg.attr('viewBox', '0,0,' + size[0] + ',' + size[1])
              textLayer.style.width = width + 'px'

              setPageRendering(false)
              onAddHighlights(num, xmlText, svg)
            }).catch(e => {
              if (requestLimit < REQUEST_LIMIT) {
                getXmlForPage(requestLimit+1)
              }
            })
        }
        getXmlForPage(requestLimit)
      }
      onCachPages(num-1)

      const percentage =  Math.ceil(num*100/pageCount)
      const read_position = {
        pointer: "#pdfloc("+bookHash+","+(num-1)+")",
        pointer_pb: "pbr:/page?page="+(num-1)+"##pdfloc("+bookHash+","+(num-1)+")",
        page: num,
        offs: percentage,
        pages_total: pageCount
      }

      if (percentage !== 0 && bookId.indexOf('.acsm') === -1) {
        updateReadPosition(read_position, bookId)
      }

      if (pageNumPending !== null) {
        setPageNumPending(null)
      }
    } else {
      setPageRendering(null)
    }

    if(view === '2page') {
      let secondNum = isNext ? num + 1 : num - 1
      let set = isNext ? true : false

      if (secondNum <= pageCount && secondNum > 0) {
        onRenderPage(secondNum, null, false, isNext, set)
      }
    }

    if (set && num <= pageCount && num > 0) {
      let page = num
      if (textFlow === '2page' && page % 2 !== 0) page = page-1
      let index = getStateIndex(prevStates, {page: page, location: page})
      let statePage = index > 0 ? page +'-'+ index : page
      if (stateIndex > 0) {
        let indexPage = prevStates[stateIndex].page
        if (indexPage.toString().indexOf('-') > -1) {
          indexPage = indexPage.split('-')[0]
        }
        if (indexPage === page) {
          statePage = indexPage
        } else {
          index = getStateIndex(prevStates, {page: page, location: page}, 0)
          statePage = index > 0 ? page + '-' + index : page
        }
      }
      replaceState({page: statePage, location: page}, stateIndex)
      window.history.replaceState({page: statePage, location: page}, null,
          document.URL);
      return {currPage: page}
    }
  },
  setOnCachPages: () => (onCachPages) => ({
    onCachPages: onCachPages
  }),
  onCachPages: ({setPagePng, setPageXml, pagesPng, pagesXml, onCachPages}, {bookInfo: {baseUrl}, pageCount}) => (num) => {
    for(let i=num-1; i<=num+2;i++) {
      if (i < 0 || i > (pageCount-1)) continue
      if (!pagesPng[i] && i !== num) {
        let requestLimit = 0
        const getPngForPage = (requestLimit) => {
          fetch(`${baseUrl}large/page-${i}.png`)
            .then(res => res.blob())
            .then(blob => {
              let objectURL = URL.createObjectURL(blob)
              setPagePng(i, objectURL)
            })
            .catch(e => {
              if (requestLimit < REQUEST_LIMIT) {
                getPngForPage(requestLimit+1)
              }
            })
        }
        getPngForPage(requestLimit)
      }

      if (!pagesXml && i !== num) {
        let requestLimit = 0
        const getXmlForPage = (requestLimit) => {
          fetch(`${baseUrl}page-${i}.xml`)
            .then(res => res.text())
            .then(xmlText => {
              if (xmlText.indexOf('BlobNotFound') > -1) return
              xmlText = xmlText.replace(/<\/l>[\s\S]*?<l/g, '</l><l')
              let xml = new XMLParser().parseFromString(xmlText);
              setPageXml(i, xml, xmlText)
            })
            .catch(e => {
              if (requestLimit < REQUEST_LIMIT) {
                getXmlForPage(requestLimit+1)
              }
            })
        }
        getXmlForPage(requestLimit)
      }
    }
  },
  onChangeTextColor: () => (bgClass) => {
    document.getElementsByTagName('body')[0].className = bgClass
  },
  queueRenderPage: ({onRenderPage}, {pageRendering, setPageNumPending, textFlow}) => (num, isNext = true) => {
    if (pageRendering) {
      setPageNumPending(num)
    } else {
      onRenderPage(num, textFlow, true, isNext)
    }
  },
  setQueueRenderPage: () => (queueRenderPage) => ({
    queueRenderPage: queueRenderPage
  }),
  onPrevPage: ({currPage, queueRenderPage}, {textFlow}) => (pageNum) => {
    if (pageNum === null) {
      pageNum = currPage
    } else if (pageNum <= 1) {
      return;
    } else if (textFlow === '2page' && pageNum <= 2) {
      return
    }

    pageNum = textFlow === '2page' ? pageNum - 2 : pageNum - 1
    queueRenderPage(pageNum, false)
  },
  onArrowPrev: () => (pageNum, queueRenderPage, onPrevPage) => {
    onPrevPage(pageNum, queueRenderPage)
  },
  onArrowNext: () => (pageNum, queueRenderPage, onNextPage) => {
    onNextPage(pageNum, queueRenderPage)
  },
  onNextPage: ({rendition, currPage, queueRenderPage}, {pageCount}) => (pageNum) => {
    if (pageNum >= pageCount) {
      return;
    } else if (pageNum === null) {
      pageNum = currPage
    }
    pageNum++
    queueRenderPage(pageNum, true)
  },
  onAddRangeRef: () => (ref) => (
      {rangeRef: ref}
  ),
  onChangeStart: () => (value) => ({
    pageOnChangeStart: value
  }),
  onChangeRange: () => (value) => ({
    currPage: value
  }),
  onChangeRangeComplete: ({currPage, pageOnChangeStart, stateIndex, queueRenderPage}, {textFlow, prevStates, addPrevState}) => (value) => {
    let index = getStateIndex(prevStates, {page: pageOnChangeStart, location: currPage})
    let statePage = index > 0 ? pageOnChangeStart +'-'+ index : pageOnChangeStart
    addPrevState(statePage, pageOnChangeStart, stateIndex)
    if (stateIndex === 0) {
      window.history.replaceState({page: statePage, location: pageOnChangeStart}, null,
          document.URL);
    }
    window.history.pushState({page: statePage, location: pageOnChangeStart}, null,
        document.URL);

    if (textFlow === '2page' && value % 2 === 0) {
      value = value - 1
    }
    queueRenderPage(value)
    return {
      currPage: value,
      backButton: {status: true, page: pageOnChangeStart, location: pageOnChangeStart},
      forwardButton: {status: false},
      stateIndex: 0
    }
  },
  onScroll: ({scrollPosition, onRenderPage, currPage}, {pageCount, pageRendering, textFlow}) => (event) => {
    if (textFlow === 'scrolling') {
      let currentOffset = event.scrollTop
      let directionDown = currentOffset > scrollPosition ? true : false
      if (pageRendering) return

      if (directionDown && event.top > 0.95) {
        if (currPage < pageCount) {
          onRenderPage(currPage + 1, textFlow, false, true)
        }
      } else if (!directionDown && event.top < 0.05){
        if (currPage-1 > 0) {
          onRenderPage(currPage - 1, textFlow, false, false)
        }
      }
      let pages = $('.page')
      for (let i=0; i < pages.length; i++) {
        let page = pages[i]
        let h = page.offsetHeight
        let offs = page.offsetTop
        let over = offs + h

        if (currentOffset < over) {
          currPage = parseInt(page.dataset.pageNumber, 10)
          break
        }
      }

      return {
        scrollPosition: currentOffset,
        currPage: currPage
      }
    }
  },
  onZoom: ({scale, onRenderPage, currPage, onResizeWindow}, {textFlow}) => (zoomOut) => {
    if (textFlow === '2page') {
      currPage = currPage - 1
    }
    scale = !zoomOut ? scale + 0.1 : scale - 0.1

    if (0.6 > scale || scale > 2) {
      return
    }

    onResizeWindow(scale)
    return {scale: scale}
  },
  onAddHighlights: ({eventEmmiter, currPage, pagesXml, rendition, UI, renderOptions, annotationStore, pagesText, target, onSelected, changeHighlighModalPosition},
                    {highlights, setEditNoteText, toggleActiveHighlight, activeHighlight, setOpenAddNote}) => (num, xml, svg) => {
    if (!highlights) return
    for (let i=0; i < highlights.length; i++) {
      let highlight = highlights[i]
      let rects = []
      if(!highlight.note) {
        let page = getPdtPosition(highlight.mark.anchor)
        let color = highlight.color ? highlight.color.value : 'yellow'
        if (page === num) {
          let offset = getOffset(highlight.quotation.begin)
          let over = getOver(highlight.quotation.end)
          let text = highlight.quotation.text
          rects = addHighlightInPage(xml, parseInt(offset, 10), parseInt(over, 10), svg, color, text)
        }
      } else {
        let page = getPdtPosition(highlight.mark.anchor)

        if (page === num) {
          let offset = getOffset(highlight.quotation.begin)
          let over = getOver(highlight.quotation.end)
          let noteText = highlight.note.text
          let text = highlight.quotation.text
          let color = highlight.color ? highlight.color.value : 'red'

          rects = addHighlightInPage(xml, parseInt(offset, 10), parseInt(over, 10), svg, color, text)
          addNoteInPage(xml, page, parseInt(offset, 10), parseInt(over, 10), svg, noteText,
              setEditNoteText, onSelected, changeHighlighModalPosition, toggleActiveHighlight, activeHighlight, setOpenAddNote, text, eventEmmiter, highlight)
        }
      }

      let emitter = function emmiter() {
        eventEmmiter.emit('markClicked', highlight)
      }
      for (let i=0; i < rects.length; i++) {
        let rect = rects[i]
        rect.addEventListener("mousedown", emitter)
        rect.addEventListener("mouseup", emitter)
      }
    }
  },
  onUpdateNote: ({eventEmmiter, pagesXml, rendition, coords, target, selectedRange, bookHash}, {textFlow, selectedNote, highlights, setEditNoteText, toggleActiveHighlight, activeHighlight, setOpenAddNote, bookId, addNote, updateNote}) => (noteText, onSelected, changeHighlighModalPosition) => {
    let note = {}
    let page
    let color
    let begin
    let end
    let text
    let xml

    if (Object.keys(selectedNote).length > 0) {
      note = selectedNote

      page = getPdtPosition(note.mark.anchor)
      color = note.color ? note.color.value : 'yellow'
      begin = getOffset(note.quotation.begin)
      end = getOver(note.quotation.end)
      text = note.quotation.text
      xml = pagesXml[page-1].xmlText

      note.type = {
        value: "note",
        updated: dateForSaveNote()
      }
      note.note = {
        text: noteText.substr(0, BOOKMARK_TEXT_LIMIT),
        updated: dateForSaveNote()
      }

      if (!note.uuid) {
        highlights.forEach(highlight => {
          if (highlight.quotation.begin === note.quotation.begin &&
            highlight.quotation.end === note.quotation.end) {
            note.uuid = highlight.uuid
          }
        })
      }

      updateNote(note.uuid, note, bookId)

      let marks = document.getElementsByClassName('mark')
      for (let i = 0; i < marks.length; i++) {
        let mark = marks[i]
        let mOffs = mark.dataset.begin
        let mOver = mark.dataset.end

        if (mOffs === begin && mOver === end) {
          $(mark).remove()
        }
      }

      let emitter = function emmiter() {
        eventEmmiter.emit('markClicked', note)
      }
      for (let i=0; i < rendition.length; i++) {
        let svg = rendition[i]
        let rects = svg.selectAll('rect')._groups[0]
        for (let l=0; l < rects.length; l++) {
          let rect = rects[l]
          let rOffs = $(rect).attr('data-offset')
          let rOver = $(rect).attr('data-over')

          if (rOffs === begin && rOver === end) {
            $(rect).removeAttr('class')
            $(rect).removeAttr('data-offset')
            $(rect).removeAttr('data-over')

            rect.removeEventListener("mousedown", emitter)
            rect.removeEventListener("mouseup", emitter)
          }
        }
      }

    } else {
      let rects = selectedRange._groups ? selectedRange._groups[0] : []
      color = 'red'

      let firstWord = ''
      let lastWord = ''

      for (let i=0; i < rects.length; i++) {
        let rect = rects[i]
        if (i === 0) {
          firstWord = $(rect).attr('data-coords')
        }
        if (i === rects.length-1) {
          lastWord = $(rect).attr('data-coords')
        }
      }

      page = $(target.target).closest('#viewer-content>div').attr('data-page-number')
      let pageNum = page-1
      xml = pagesXml[pageNum].xmlText
      let position = getTextPosition(xml, firstWord, lastWord, rects)

      begin = position.offs
      end = position.over
      text = position.text

      if (position.text.length === 0) return

      note = {
        type: {
          value: "note",
          updated: dateForSaveNote()
        },
        color: {
          value: color,
          updated: dateForSaveNote()
        },
        note: {
          text: noteText.substr(0, BOOKMARK_TEXT_LIMIT),
          updated: dateForSaveNote()
        },
        mark: {
          anchor: "pbr:/word?page="+pageNum+"&offs="+begin+"##pdfloc("+bookHash+","+pageNum+")",
          created:  Math.round(new Date() / 1000),
          updated: dateForSaveNote()
        },
        quotation: {
          begin: "pbr:/word?page="+pageNum+"&offs="+begin+"##pdfloc("+bookHash+","+pageNum+")",
          end: "pbr:/char?page="+pageNum+"&over="+end+"##pdfloc("+bookHash+","+pageNum+")",
          text: position.text.substr(0, BOOKMARK_TEXT_LIMIT),
          updated: dateForSaveNote()
        }
      }

      addNote(note, bookId, true)
    }
    let svg = rendition[0]
    if (page % 2 === 0 && textFlow === '2page') {
      svg = rendition[1]
    }

    let rects = addHighlightInPage(xml, parseInt(begin, 10), parseInt(end, 10), svg, color, text)
    addNoteInPage(xml, page, parseInt(begin, 10), parseInt(end, 10), svg, noteText,
      setEditNoteText, onSelected, changeHighlighModalPosition, toggleActiveHighlight, activeHighlight, setOpenAddNote, text, eventEmmiter, note)

    let emitter = function emmiter() {
      eventEmmiter.emit('markClicked', note)
    }
    for (let i=0; i < rects.length; i++) {
      let rect = rects[i]
      rect.addEventListener("mousedown", emitter)
      rect.addEventListener("mouseup", emitter)
    }
  },
  setUI: () => (UI) => ({
    UI: UI
  }),
  setRenderOptions: () => (options) => ({
    renderOptions: options
  }),
  onSelected: () => (range = '', text = '', uuid = '', target = '', coords = '') => {
    if (!range) return
    return {
      selectedRange: range,
      selectedText: text,
      selectedHighlight: uuid,
      target: target,
      coords: coords
    }
  },
  onSelectedColor: () => (color) => (
      {selectedHighlightColor: color}
  ),
  onAddNote: ({rendition, eventEmmiter, selectedHighlightColor, selectedRange, target, pagesXml, bookHash}, { selectedNote, bookId, addNote, highlights, updateNote, setSelectedNote, setOpenAddNote }) => (onSelected, isUpdate) => {
    let note = {}
    let rects = []
    let begin
    let end

    if (isUpdate) {
      note = selectedNote
      note.color.value = selectedHighlightColor
      note.color.updated = dateForSaveNote()
      begin = getOffset(note.quotation.begin)
      end = getOver(note.quotation.end)

      if (!note.uuid) {
        highlights.forEach(highlight => {
          if (highlight.quotation.begin === note.quotation.begin &&
            highlight.quotation.end === note.quotation.end) {
            note.uuid = highlight.uuid
          }
        })
      }

      updateNote(note.uuid, note, bookId)
      setSelectedNote(note)

      let emitter = function emmiter() {
        eventEmmiter.emit('markClicked', note)
      }

      for (let i=0; i < rendition.length; i++) {
        let svg = rendition[i]
        let rRects = svg.selectAll('rect')._groups[0]
        for (let l=0; l < rRects.length; l++) {
          let rect = rRects[l]
          let rOffs = $(rect).attr('data-offset')
          let rOver = $(rect).attr('data-over')

          if (rOffs === begin && rOver === end) {
            rects.push(rect)
            $(rect).removeAttr('class')
            $(rect).removeAttr('data-offset')
            $(rect).removeAttr('data-over')

            rect.removeEventListener("mousedown", emitter)
            rect.removeEventListener("mouseup", emitter)
          }
        }
      }
    } else {
      let firstWord = ''
      let lastWord = ''
      rects = selectedRange._groups[0]

      for (let i=0; i < rects.length; i++) {
        let rect = rects[i]
        if (i === 0) {
          firstWord = $(rect).attr('data-coords')
        }
        if (i === selectedRange._groups[0].length-1) {
          lastWord = $(rect).attr('data-coords')
        }
      }
      let pageNum = $(target.target).closest('#viewer-content>div').data('page-number') - 1
      let xml = pagesXml[pageNum].xmlText
      let position = getTextPosition(xml, firstWord, lastWord, rects)
      begin = position.offs
      end = position.over

      if (position.text.length === 0) return

      note = {
        type: {
          value: "highlight",
          updated: dateForSaveNote()
        },
        color: {
          value: selectedHighlightColor,
          updated: dateForSaveNote()
        },
        mark: {
          anchor: "pbr:/word?page="+pageNum+"&offs="+begin+"##pdfloc("+bookHash+","+pageNum+")",
          created:  Math.round(new Date() / 1000),
          updated: dateForSaveNote()
        },
        quotation: {
          begin: "pbr:/word?page="+pageNum+"&offs="+begin+"##pdfloc("+bookHash+","+pageNum+")",
          end: "pbr:/char?page="+pageNum+"&over="+end+"##pdfloc("+bookHash+","+pageNum+")",
          text: position.text.substr(0, BOOKMARK_TEXT_LIMIT),
          updated: dateForSaveNote()
        }
      }

      addNote(note, bookId, true)
    }

    let emitter = function emmiter() {
      eventEmmiter.emit('markClicked', note)
    }

    for (let i=0; i < rects.length; i++) {
      let rect = rects[i]
      rect = setRect(rect, selectedHighlightColor, begin, end)
      rect.addEventListener("mousedown", emitter)
      rect.addEventListener("mouseup", emitter)
    }
  },
  onCopyText: ({selectedRange, pagesXml, target}) => () => {
    const rects = selectedRange._groups ? selectedRange._groups[0] : null

    if (!rects) return;

    let firstWord = ''
    let lastWord = ''

    for (let i=0; i < rects.length; i++) {
      let rect = rects[i]
      if (i === 0) {
        firstWord = $(rect).attr('data-coords')
      }
      if (i === selectedRange._groups[0].length-1) {
        lastWord = $(rect).attr('data-coords')
      }
    }

    const pageNum = $(target.target).closest('#viewer-content>div').data('page-number') - 1
    const xml = pagesXml[pageNum].xmlText
    const position = getTextPosition(xml, firstWord, lastWord, rects)

    const text = position.text;

    navigator.clipboard.writeText(text).then(function() {
      console.log('Async: Copying to clipboard was successful!');
    }, function(err) {
      console.error('Async: Could not copy text: ', err);
    });
  },
  setPagesText: ({pagesText}) => (text, clear) => {
    if (clear) {
      pagesText = []
    }
    pagesText.push(text)
    return {pagesText: pagesText}
  },
  onSetPagesText: () => (setPagesText) => {
    return {setPagesText: setPagesText}
  },
  setOnSelected: () => (onSelected) => ({
    onSelected: onSelected
  }),
  setChangeHighlighModalPosition: () => (changeHighlighModalPosition) => ({
    changeHighlighModalPosition: changeHighlighModalPosition
  }),
  setPageXml: ({pagesXml}) => (page, xml, xmlText) => {
    pagesXml[page] = {
      xml: xml,
      xmlText: xmlText
    }
    return {pagesXml: pagesXml}
  },
  onSetPagesXml: () => (setPageXml) => ({
    setPageXml: setPageXml
  }),
  setPagePng: ({pagesPng}) => (page, png) => {
    pagesPng[page] = png
    return {pagesPng: pagesPng}
  },
  onSetPagesPng: () => (setPagePng) => ({
    setPagePng: setPagePng
  }),
  onResizeWindow: ({scale}, {textFlow}) => (newScale) => {
    if (newScale) scale = newScale

    let pngs = document.getElementsByClassName('pngWrapper')
    let svgs = document.getElementsByClassName('svgWrapper')
    let viewerContent = document.getElementById('viewer-content')

    let width = viewerContent.offsetWidth*scale
    if (textFlow === '2page') {
      width = (width/2) - 40
    } else if ($(viewerContent).parent().css('padding-left') === '20px') {
      width = width - 40
    }
    for (let i=0;i<pngs.length;i++) {
      let png = pngs[i]
      png.style.width = width + 'px'
    }
    for (let i=0;i<svgs.length;i++) {
      let svg = svgs[i]
      svg.style.width = width + 'px'
    }
  },
  setOnResizeWindow: () => (onResizeWindow) => ({
    onResizeWindow: onResizeWindow
  }),
  goBack: ({onRenderPage, changeIndex}, {prevStates, textFlow, access_token, refresh_token}) => (e) => {
    if (!e.state || !e.state.page || prevStates.length <= 1) {
      window.location = CLOUD_URL
      return
    }

    let state = e.state
    let page = state.page
    let currIndex = 0

    for (let i=0; i < prevStates.length; i++) {
      let prevState = prevStates[i]
      if (isEqual(prevState, state)) {
        currIndex = i
        break
      }
    }

    let forwardButton = {status: false}
    if (currIndex !== 0) {
      forwardButton.status = true
      forwardButton.page = prevStates[currIndex-1].page
      if (forwardButton.page.toString().indexOf('-') > -1) {
        forwardButton.page = forwardButton.page.toString().split('-')[0]
      }
      forwardButton.location = prevStates[currIndex-1].location
    }
    let backButton = {status: false}
    if (currIndex !== (prevStates.length-1)) {
      backButton.status = true
      backButton.page = prevStates[currIndex+1].page
      if (backButton.page.toString().indexOf('-') > -1) {
        backButton.page = backButton.page.toString().split('-')[0]
      }
      backButton.location = prevStates[currIndex+1].location
    }

    changeIndex(currIndex)
    if (page.toString().indexOf('-') > -1) {
      page = page.toString().split('-')[0]
    }

    if (textFlow === '2page' && page % 2 === 0) {
      page = page - 1
    }
    onRenderPage(page, textFlow)
    return {
      currPage: page,
      forwardButton: forwardButton,
      backButton: backButton
    }
  },
  onBackButton: () => () => {
    window.history.back()
  },
  onForwardButton: () => () => {
    window.history.forward()
  },
  changeIndex: () => (index) => ({
    stateIndex: index,
  }),
  setChangeIndex: () => (changeIndex) => ({
    changeIndex: changeIndex
  }),
  setEvents: () => (events) => ({
    eventEmmiter: events
  }),
  onOpenHighlightModal: ({rendition, changeHighlighModalPosition, onSelected}, {selectedNote, toggleActiveHighlight, activeHighlight, setOpenAddNote}) => (e, drag) => {
    let selected = []
    for (let i=0; i < rendition.length; i++) {
      let svg = rendition[i]
      let rects = svg.selectAll('rect')._groups[0]
      for (let l=0; l < rects.length; l++) {
        let rect = rects[l]
        if ($(rect).hasClass('selected')) {
          selected.push(rect)
        }
      }
    }
    if (drag && selected.length > 0) {
      if (!e.target.href || e.target.tagName.toLowerCase() !== 'a') {
        onMouseUp(e, changeHighlighModalPosition, toggleActiveHighlight,
          activeHighlight, onSelected, setOpenAddNote, '', true, true, drag)
      }
    } else if (selectedNote && Object.keys(selectedNote).length > 0 && selected.length === 0) {
      onMouseUp(e, changeHighlighModalPosition, toggleActiveHighlight,
        activeHighlight, onSelected, setOpenAddNote, 'openEditHighlight', true, true, drag)
    } else {
      toggleActiveHighlight(false)
    }
  }
}

const mapStateToProps = (state) => ({
  bookInfo: state.reader.bookInfo,
  book: state.reader.book,
  bookId: state.reader.bookId,
  bookUrl: state.reader.bookUrl,
  pageCount: state.reader.pageCount,
  currPage: state.reader.currPage,
  pageNumPending: state.reader.pageNumPending,
  pageRendering: state.reader.pageRendering,
  textColor: state.appearence.color,
  textSize: state.appearence.size,
  textFont: state.appearence.font,
  textFlow: state.appearence.flow,
  bookmarks: state.reader.bookmarks,
  highlights: state.reader.highlights,
  activeHighlight: state.reader.activeHighlight,
  language: state.userData.language,
  pageReady: state.reader.pageReady,
  prevStates: state.reader.prevStates,
  access_token: state.reader.userData.access_token,
  refresh_token: state.reader.userData.refresh_token,
  bookReady: state.reader.bookReady,
  selectedNote: state.reader.selectedNote
})

const mapDispatchToProps = (dispatch) => ({
  setPageCount: (count) => dispatch(setPageCount(count)),
  setCurrPage: (page) => dispatch(setCurrPage(page)),
  setBookReady: (status) => dispatch(setBookReady(status)),
  setPageReady: (status) => dispatch(setPageReady(status)),
  setBookLoadingProgress: (progress) => dispatch(setBookLoadingProgress(progress)),
  setPageRendering: (status) => dispatch(setPageRendering(status)),
  setPageNumPending: (num) => dispatch(setPageNumPending(num)),
  updateReadPosition: (read_position, bookId) => dispatch(updateReadPosition(read_position, bookId)),
  setChapters: (chapters) => dispatch(setChapters(chapters)),
  setFullscreenMode: (status) => dispatch(setFullscreenMode(status)),
  nextDropdown: (id) => dispatch(nextDropdown(id)),
  addNote: (note, path, isHighlight) => dispatch(addNote(note, path, isHighlight)),
  setInBookmarks: (status) => dispatch(setInBookmarks(status)),
  toggleActiveHighlight: (status) => dispatch(highlightAction(status)),
  setOpenAddNote: (status) => dispatch(setOpenAddNote(status)),
  setEditNoteText: (text) => dispatch(setEditNoteText(text)),
  setSearchResult: (result) => dispatch(setSearchResult(result)),
  setTextColor: (color) => dispatch(setAppearenceTextColor(color)),
  addPrevState: (page, location, index) => dispatch(addPrevState(page, location, index)),
  removePrevState: () => dispatch(removePrevState()),
  replaceState: (state, index) => dispatch(replaceState(state, index)),
  deleteNote: (id, path, type ) => dispatch(deleteNote(id, path, type )),
  updateNote: (id, note, path) => dispatch(updateNote(id, note, path)),
  setSelectedNote: (note) => dispatch(setSelectedNote(note))
})

export const enhance = compose(
    setDisplayName('Pdf Reader'),
    connect(mapStateToProps, mapDispatchToProps),
    withStateHandlers(state, stateHandlers)
)

export class View extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      highlightModalTop: 0,
      highlightModalLeft: 0
    }

    this.changeHighlighModalPosition = this.changeHighlighModalPosition.bind(this)
  }

  changeHighlighModalPosition(top, left) {
    this.setState({highlightModalTop: top, highlightModalLeft: left})
  }

  componentDidMount () {
    const { props: { bookInfo, setCurrPage, setPageCount, setBookReady, onGetChapters, textColor,
      setFullscreenMode, nextDropdown, textFlow, setBookHash, book, setAddHighlightsMethod, onAddHighlights,
      onSelected, setQueueRenderPage,
      onSetPagesText, setPagesText, setOnSelected, setChangeHighlighModalPosition,
      queueRenderPage, onArrowPrev, onArrowNext, onPrevPage, onNextPage, onRenderPage, onCopyText,
      setOnRenderPage, onSetPagesXml, setPageXml, onSetPagesPng, setPagePng, setOnCachPages, onCachPages,
      setOnLoad, onLoad, onResizeWindow, onOpenHighlightModal, setTextColor, setPageReady, goBack,
      setChangeIndex, changeIndex, setEvents, setSelectedNote, toggleActiveHighlight, setOnResizeWindow}} = this

    window.history.replaceState({'status': 'loaded'}, null, document.URL);
    window.history.pushState({'status': 'loaded'}, null, document.URL);

    let bgClass
    if (textColor === 'pale' || textColor === 'very_light_pink') {
      bgClass = 'white'
      setTextColor('white')
    } else {
      bgClass = textColor
    }

    setOnResizeWindow(onResizeWindow)
    setPageReady(true)
    setOnRenderPage(onRenderPage)
    setOnSelected(onSelected)
    setChangeHighlighModalPosition(this.changeHighlighModalPosition)
    onSetPagesXml(setPageXml)
    onSetPagesPng(setPagePng)
    setOnCachPages(onCachPages)
    setOnLoad(onLoad)
    setChangeIndex(changeIndex)
    setQueueRenderPage(queueRenderPage)
    let startPage = bookInfo.position ? getPdtPosition(bookInfo.position.pointer) : 1

    if (textFlow === '2page' && startPage % 2 === 0) {
      startPage = startPage - 1
      setCurrPage(startPage)
    } else {
      setCurrPage(startPage)
    }
    setPageCount(bookInfo.pages.count)
    setAddHighlightsMethod(onAddHighlights)
    setBookHash(book.bytes)
    onSetPagesText(setPagesText)

    onRenderPage(startPage, textFlow)
    setBookReady(true)
    onGetChapters()
    document.getElementsByTagName('body')[0].className = bgClass

    let fullscreenStatus = false
    const toggleFullscreen = () => {
      setFullscreenMode(!fullscreenStatus)
      fullscreenStatus = !fullscreenStatus
      const root = document.getElementById('root')
      root.classList.toggle('fullscreen')
    }

    if (document.addEventListener) {
      document.addEventListener('webkitfullscreenchange', toggleFullscreen, false);
      document.addEventListener('mozfullscreenchange', toggleFullscreen, false);
      document.addEventListener('fullscreenchange', toggleFullscreen, false);
      document.addEventListener('MSFullscreenChange', toggleFullscreen, false);

      closePopups(document, nextDropdown)
    }

    let drag = false
    document.querySelector('body').addEventListener('mousedown', e => {
      closePopups(document, nextDropdown)

      drag = false

      let marks = []
      let popup = []
      notChildren(marks, e.target, document.getElementsByClassName('mark'))
      notChildren(popup, e.target, document.getElementById('HighlightModal__wrapper').children)
      if (!(popup.indexOf(false)> -1) && !(marks.indexOf(false) > -1)) {
        setSelectedNote({})
        onSelected('')
        toggleActiveHighlight(false)

        let marks = document.getElementsByClassName('mark')
        for (let i=0; i< marks.length; i++) {
          let mark = marks[i]
          mark.classList.remove('open')
        }
      }
    })
    document.querySelector('body').addEventListener('mousemove', e => {
      drag = true
    })
    document.querySelector('body').addEventListener('mouseup', e => {
      let popup = []
      let range = []
      let bookInfo = []
      notChildren(popup, e.target, document.getElementById('HighlightModal__wrapper').children)
      notChildren(range, e.target, document.getElementsByClassName('pageCount')[0].children)
      notChildren(bookInfo, e.target, document.getElementsByClassName('BookInfo').children)
      if (!(popup.indexOf(false) > -1) && !(range.indexOf(false) > -1) && !(bookInfo.indexOf(false) > -1)) {
        onOpenHighlightModal(e, drag)
      }
    })

    document.addEventListener('keydown', (e) => {
      e = e || window.event
      if (e.target.type === 'text') return;
      if (e.keyCode === 38 || e.keyCode === 37 || e.keyCode === 33) {
        onArrowPrev(null, queueRenderPage, onPrevPage)
      }
      else if (e.keyCode === 40 || e.keyCode === 39 || e.keyCode === 34) {
        onArrowNext(null, queueRenderPage, onNextPage)
      }
    })

    window.addEventListener('resize', () => {
      onResizeWindow()
    })

    window.addEventListener('popstate', (e) => {
      goBack(e)
    });

    const ctrlKey = 17;
    const cmdKey = 91;
    const cKey = 67;

    let ctrlDown = false;

    $(document).keydown(function(e) {
      if (e.keyCode === ctrlKey || e.keyCode === cmdKey) ctrlDown = true;
    }).keyup(function(e) {
      if (e.keyCode === ctrlKey || e.keyCode === cmdKey) ctrlDown = false;
    });

    $(document).keydown(function(e) {
      if (ctrlDown && (e.keyCode === cKey)) {
        onCopyText();
      }
    });

    let EventsEmitter = new events.EventEmitter()
    setEvents(EventsEmitter)
    EventsEmitter.on('markClicked', note => {
      setSelectedNote(note)
    })
  }

  render() {
    const {props: { onAddRangeRef, currPage, onChangeRange, queueRenderPage, onNextPage,
      onPrevPage, onSaveReaderPosition, onChangeRangeComplete, onChangeChapter, onChangeTextColor,
      onChangeViewMode, textFlow, onZoom, scale, onScroll, onLoadBookMark, onAddBookMark, addNote, onChangeStart,
      onDeleteNote, onLoadHighlight, activeHighlight, toggleActiveHighlight, onSelected, onSelectedColor,
      onAddNote, onUpdateNote, onSearch, pageReady, onBackButton, onForwardButton, backButton, forwardButton, bookReady, onSetTextSelected, selectedHighlightColor }} = this

    return (
        <div className="PdfReader">
          { bookReady ?
            <Navigation onSaveReaderPosition={onSaveReaderPosition} onChangeChapter={onChangeChapter}
                      onChangeTextColor={onChangeTextColor} onChangeViewMode={onChangeViewMode}
                      onZoom={onZoom} scale={scale} onLoadBookMark={onLoadBookMark} onAddBookMark={onAddBookMark}
                      onDeleteNote={onDeleteNote} onLoadHighlight={onLoadHighlight}
                      onSearch={onSearch} onChangePage={queueRenderPage}/> :
            ''
          }
          <button
            className="navigation-prev-page icon-btn"
            onClick={() => onPrevPage(currPage, queueRenderPage)}
          ></button>
          <button
            className="navigation-next-page icon-btn"
            onClick={() => onNextPage(currPage, queueRenderPage)}
          ></button>
          <div
            id="viewer"
            className={`spreads pdf withScroll ${textFlow === '2page' ? 
              'two-page-view' : 
              textFlow === 'scrolling' ? 
                textFlow : 
                ''}`}
          >
            <Scrollbars style={{ width: '100%', height: '100%' }}
                        onScrollFrame={(e) => onScroll(e)}
            >
              <div id="viewer-content"></div>
            </Scrollbars>
            <Loading active={!pageReady}/>
          </div>
          <Pagination
            backButton={backButton}
            forwardButton={forwardButton}
            onBackButton={onBackButton}
            onForwardButton={onForwardButton}
            onAddRangeRef={onAddRangeRef}
            onChangeStart={onChangeStart}
            onChangeRange={onChangeRange}
            onChangeRangeComplete={onChangeRangeComplete}
            currPage={currPage}
          />
          <HighlightModal
            active={activeHighlight}
            loading={false}
            highlightModalTop={this.state.highlightModalTop}
            highlightModalLeft={this.state.highlightModalLeft}
            onAddBookMark={onAddBookMark}
            onAddNote={onAddNote}
            onSelectedColor={onSelectedColor}
            addNote={addNote}
            selectedColor={selectedHighlightColor}
            toggleActiveHighlight={toggleActiveHighlight}
            onDeleteNote={onDeleteNote}
            onSelected={onSelected}
            onSetTextSelected={onSetTextSelected}
            onUpdateNote={onUpdateNote}
            changeHighlighModalPosition={this.changeHighlighModalPosition}
          />
        </div>
    )
  }
}

export const PdfReader = enhance(View)


// WEBPACK FOOTER //
// ./src/components/Formats/PdfReader/PdfReader.js